import React from "react";
import { Divider, Form, Input, List, Modal } from "antd";
import _ from "lodash";
import { SUCCESS_COLOR } from "../../constants/color";
import { POST } from "../../frameworks/HttpClient";
import { URL_LAB } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";

export default function ConfirmLabResultsModal(props) {

  const { open, onClose, data, onUpdate, target} = props;
  const [loading, setLoading] = React.useState(false)
  const [errorMessages, setErrorMessages ] = React.useState(null);
  const results = _.get(data, 'results', [])
  const inputs = _.get(data, 'inputs', [])

  const handleOK = async() => {
    setLoading(true)
    setErrorMessages(null)
    const isCreate = (target && target.id ? false : true)
      try {
        if(isCreate){
          await POST(URL_LAB.LAB_ORDER, data)
          onUpdate();
        } else {
          await POST(`${URL_LAB.LAB_ORDER}${target.id}/lab/`, data)
          onUpdate();
        }  
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    } 
  }

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

	return(
    <Modal
      open={open}
      onCancel={onClose}
      centered={true}
      okText={"ยืนยัน"}
      okButtonProps={{ style: { backgroundColor : SUCCESS_COLOR}, loading: loading }}
      cancelText={"ยกเลิก"}
      cancelButtonProps={{ loading: loading }}
      title={"ยืนยันส่งผลแล็บ"}
      onOk={handleOK}
      width={500}
    >
      <ErrorMessages message={errorMessages} />
      {results.length > 0 && 
      <>
        <center><div style={{ fontSize : 18, fontWeight : 'bolder', marginBottom : 8 }}>ผลแล็บ</div></center>
        <div
          id="scrollableDiv"
          style={{
            height:results.length > 7 ? 300 : 'auto',
            overflow: 'auto',
            padding: '0 16px',
            border: '1px solid rgba(140, 140, 140, 0.35)',
          }}
          >
            {data && <List
              itemLayout="horizontal"
              dataSource={results}
              style={{ padding : 0}}
              renderItem={(item, index) => (
                  <>
                    <List.Item
                      style={{ padding: 6 }}
                    >
                      <List.Item.Meta
                        style={{ marginBottom : 0, marginTop : 5}}
                        title={
                        <>
                          <a style={{ marginLeft : 0 }}>{item.chemical} : {item.amount}</a>
                        </>}
                      />
                    </List.Item>
                  </>
              )}
            />}
        </div>
      </>
      }

    {inputs.length > 0 && 
      <>
        <center><div style={{ fontSize : 18, fontWeight : 'bolder', marginTop : 20, marginBottom : 8}}>เติมสารเคมี</div></center>
        <div
          id="scrollableDiv"
          style={{
            height:inputs.length > 7 ? 300 : 'auto',
            overflow: 'auto',
            padding: '0 16px',
            border: '1px solid rgba(140, 140, 140, 0.35)',
          }}
          >
          <List
            itemLayout="horizontal"
            dataSource={inputs}
            style={{ padding : 0 }}
            renderItem={(item, index) => (
                <List.Item
                  style={{ padding: 6 }}
                >
                  <List.Item.Meta
                    style={{ marginBottom : 0, marginTop : 5}}
                    title={
                    <>
                      {/* {index === 0 && <Divider/>} */}
                      <a style={{ marginLeft : 0 }}>{item.chemical} : {item.amount}</a>
                    </>}
                  />
                </List.Item>
            )}
          />
        </div>
      </>}
      {results.length === 0 && inputs.length === 0 && <div>คุณยืนยันส่งผลแล็บใช่หรือไม่</div> }
    </Modal>
)
}